import InformacoesAdicionaisRepresentanteModel from "@/models/informacoesAdicionaisRepresentanteModel";
import nfetch from "@/utils/events/nfetch";

class InformacoesAdicionaisRepresentanteService {
    private controllerName = "InformacoesAdicionaisRepresentante";

    public getList(registroId: number, tipoCadastro: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetList?registroId=${registroId}&tipoCadastro=${tipoCadastro}`, {
            credentials: "same-origin",
        });
    }

    public async insert(model: InformacoesAdicionaisRepresentanteModel): Promise<Response> {
        return await nfetch(`/${this.controllerName}/Insert`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify(model),
        });
    }
}

export default new InformacoesAdicionaisRepresentanteService();
